/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiEmailStatus } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of EmailStatusController.
 */
export class EmailStatusRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /email_status:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiEmailStatus>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiEmailStatus>>>('/email_status:query', query);
    }

    /**
     * Calls POST /email_status:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiEmailStatus>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiEmailStatus>>, ListRequest>('/email_status:query', listRequest, query);
    }

    /**
     * Calls POST /email_status:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiEmailStatus>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiEmailStatus>>, ListRequestWithIds>('/email_status:batch', listRequest, query);
    }

    /**
     * Calls GET /email_status/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiEmailStatus>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiEmailStatus>>(`/email_status/${primaryId}`, query);
    }

    /**
     * Calls PATCH /email_status
     */
    public putRange(dtos: ApiEmailStatus[]): Promise<Result<ApiEmailStatus[]>> {
        return this.http.patch<Result<ApiEmailStatus[]>, ApiEmailStatus[]>('/email_status', dtos);
    }
}
